import { propsCallback } from "./blueprint";
export var createSimpleLifecycle = function (kind, callback) {
    return ({ instanceCallbacks: [{ kind: kind, callback: function (props) { return function () { return callback(props); }; } }] });
};
export var createComparingLifecycle = function (kind, callback) {
    return ({
        instanceCallbacks: function () {
            var prevProps;
            return [
                propsCallback(function (props) {
                    if (prevProps === undefined) {
                        prevProps = props;
                    }
                    return props;
                }),
                {
                    kind: kind, callback: function (props) { return function () {
                        var prevPropsTmp = prevProps;
                        prevProps = props;
                        var result = callback(prevPropsTmp, props);
                        return result;
                    }; },
                },
            ];
        },
    });
};

//# sourceMappingURL=lifecycle.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/lifecycle.js
// module id = 14
// module chunks = 0